import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToPricing = () => {
    const go = () => document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
    go();
    setTimeout(go, 600);
    setTimeout(go, 1200);
  };
  return <section className="pb-6 md:pb-12 px-4 bg-white" data-id="element-98">
      <div className="bg-white border-b border-gray-100 py-2 md:py-4 mb-6 md:mb-10 text-center" data-id="element-99">
        <span className="text-base md:text-xl font-black text-gray-900 tracking-wide" data-id="element-100">
          ✨ MI ESPACIO INTERIOR
        </span>
      </div>
      <div className="max-w-3xl mx-auto text-center" data-id="element-101">
        <h1 className="text-2xl md:text-5xl font-black text-gray-900 mb-4 md:mb-6 leading-tight" data-id="element-102">
          Todo lo que tu hijo necesita para su mundo emocional
        </h1>

        <button onClick={scrollToPricing} className="w-3/4 max-w-xs md:w-full md:max-w-lg mx-auto block cursor-pointer md:hover:scale-105 md:transition-transform md:duration-300" data-id="element-103">
          <img src="https://cdn.magicpatterns.com/uploads/bvNaCJNSpt16izE7HrX56h/Coleccion_MEGAPACK__transforma_tu_mundo_interior_(1).webp" alt="MegaPack Mi Espacio Interior" className="w-full h-auto md:drop-shadow-2xl mb-5 md:mb-8 rounded-xl" fetchPriority="high" decoding="auto" loading="eager" sizes="(max-width: 768px) 75vw, 512px" width={1080} height={1080} style={{
          aspectRatio: '1/1',
          objectFit: 'contain'
        }} data-id="element-104" />
        </button>

        <div className="bg-yellow-100 border-l-4 border-yellow-500 p-3 md:p-4 mb-5 md:mb-8 text-left md:text-center" data-id="element-105">
          <p className="text-sm md:text-xl font-medium text-gray-800" data-id="element-106">
            El sistema N°1 de desarrollo emocional para adolescentes — 12 a 18
            años — Todos los niveles. Herramientas + ejercicios + guías listos
            para usar. Sin buscar. Sin improvisar. Sin perder más días sin saber
            cómo ayudar.
          </p>
        </div>

        <div className="max-w-md mx-auto" data-id="element-107">
          <CTAButton text="✨ QUIERO MI ESPACIO INTERIOR AHORA" subtext="📄 100% PDF • ⚡ Acceso inmediato • 🛡️ Garantía 7 días" size="sm" data-id="element-108" />
        </div>
      </div>
    </section>;
}